export default __webpack_public_path__ + "static/media/logo_big.7382177c.png";